const banner = {
  imgPath: "Picture",
  linkPath: "Link URL",
  selectImg: "Select Picture",
  error1: "Please select a picture",
  error2: "Please enter a description",
  addbanner: "Add banner",
  editbanner: "Edit banner"
} 
export default banner